module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<section class="content-header">\r\n    <h1>\r\n        '+
((__t=(attributes.lang.PROFILE_TITLE))==null?'':_.escape(__t))+
'\r\n            <small>'+
((__t=(attributes.first_name))==null?'':_.escape(__t))+
' '+
((__t=(attributes.last_name))==null?'':_.escape(__t))+
'</small>\r\n    </h1>\r\n</section>\r\n\r\n<section class="content">\r\n    <div class="row">\r\n        <div class="col-md-8">\r\n            <div class="box">\r\n                <div class="box-body">\r\n\r\n                    <form id="userProfile">\r\n                        <div class="form-group">\r\n\r\n                        </div>\r\n                        <div class="form-group">\r\n                            <label for="first_name">'+
((__t=(attributes.lang.NAME))==null?'':_.escape(__t))+
'</label>\r\n                            <input type="text" id="first_name" name="last_name" class="form-control" placeholder="'+
((__t=(attributes.lang.NAME))==null?'':_.escape(__t))+
'" value="'+
((__t=(attributes.first_name))==null?'':_.escape(__t))+
'" required/>\r\n                        </div>\r\n                        <div class="form-group">\r\n                            <label for="last_name">'+
((__t=(attributes.lang.LAST_NAME))==null?'':_.escape(__t))+
'</label>\r\n                            <input type="text" id="last_name" name="last_name" class="form-control" placeholder="'+
((__t=(attributes.lang.LAST_NAME))==null?'':_.escape(__t))+
'" value="'+
((__t=(attributes.last_name))==null?'':_.escape(__t))+
'" required/>\r\n                        </div>\r\n                        <div class="form-group">\r\n                            <label for="username">'+
((__t=(attributes.lang.EMAIL))==null?'':_.escape(__t))+
'</label>\r\n                            <input type="text" id="username" name="username" class="form-control" placeholder="'+
((__t=(attributes.lang.EMAIL))==null?'':_.escape(__t))+
'" value="'+
((__t=(attributes.username))==null?'':_.escape(__t))+
'" required/>\r\n                        </div>\r\n                        <div class="form-group">\r\n                            <label for="language">'+
((__t=(attributes.lang.LANGUAGE))==null?'':_.escape(__t))+
'</label>\r\n                            <select id="language" name="language" class="form-control"> \r\n                                <option value="es" '+
((__t=(attributes.language==='es'?'selected':''))==null?'':_.escape(__t))+
'>Español</option>\r\n                            </select>\r\n                        </div>\r\n                        <div class="form-group">\r\n                            <button type="button" class="btn btn-info" id="back"><span class="glyphicon glyphicon-arrow-left"></span>'+
((__t=(attributes.lang.BACK))==null?'':_.escape(__t))+
'</button>\r\n                            <button type="submit" class="btn btn-success" id="save">'+
((__t=(attributes.lang.SAVE))==null?'':_.escape(__t))+
'</button>\r\n                        </div>\r\n                    </form>\r\n\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</section>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/profile/profileView.ejs
// module id = 440
// module chunks = 0